export { default } from './SpecialOfferBadge'
